module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ../~/aws-sdk/apis/cognito-identity-2014-06-30.paginators.json
// module id = 594
// module chunks = 0